import type { Middleware, RequestContext } from "core/api/coreApiClient";
import { getStore } from "core/redux/store/configureStore";

export const API_URL_IDENTIFIER = "API_URL";

type AppHeadersInit = HeadersInit & {
  "X-Timezone": string;
};

let fetchSectionsRequestsAbortController = new AbortController();

export function abortFetchSectionsRequests() {
  fetchSectionsRequestsAbortController.abort();
  // creates a new controller otherwise future requests will also be cancelled
  fetchSectionsRequestsAbortController = new AbortController();
}

class RequestFormatterMiddleware implements Middleware {
  finalUrl?: string;

  pre = async (context: RequestContext) => {
    const { url, init: config } = context;

    const finalConfig = config ? { ...config } : {};

    const { apiUrl, jsfUrl, timeZone, jsfContextPath } = getStore().getState().configuration;

    let finalUrl = url;

    // In case the api url identifier is used, we replace that string with the base api url
    if (finalUrl.match(API_URL_IDENTIFIER)) {
      finalUrl = finalUrl.replace(API_URL_IDENTIFIER, apiUrl);
    }

    // Prepend the url with API domain
    if (!finalUrl.startsWith("http") && !finalUrl.match("client-build-id")) {
      finalUrl = apiUrl + finalUrl;
    }

    if (jsfContextPath) {
      // In some cases (confirm response), the page is not under the API (aorta), so we format the URL differently
      finalUrl = finalUrl.replace(`${jsfContextPath}/aorta${jsfContextPath}/`, `${jsfContextPath}/`);
    }

    // In some cases, the page is not under the API (aorta), so we format the URL differently
    finalUrl = finalUrl.replace("/aorta/invoke/", "/invoke/");

    let credentials: RequestCredentials = "omit";
    if (finalUrl.match(jsfUrl) || finalUrl.match(apiUrl) || finalUrl.match("fileDownloadToken")) {
      credentials = "include";
    }

    if (finalUrl.match(apiUrl)) {
      // Send the timeZone to the API
      if (!finalConfig.headers) finalConfig.headers = {};
      (finalConfig.headers as AppHeadersInit)["X-Timezone"] = timeZone;
    }

    finalConfig.credentials = credentials;
    finalConfig.signal =
      finalUrl.match("retryOnFailure") && finalUrl.match("/sections/")
        ? fetchSectionsRequestsAbortController.signal
        : undefined;

    this.finalUrl = finalUrl;

    return Promise.resolve({
      ...context,
      url: finalUrl,
      init: finalConfig,
    });
  };
}

export default RequestFormatterMiddleware;
